<!--
 * @Description: 新增商机
 * @Author: mdb
 * @Date: 2022-07-01 15:31:13
 * @LastEditTime: 2023-03-07 15:28:24
 * @LastEditors: mdb
-->
<template>
  <CosLayoutMain>
    <template #content>
      <BusinessForm
        ref="businessFormRef"
        :title="t('business.luzk2t')"
        type="add"
        v-model:value="dataForm"
        :saleChanceRefId="saleChanceRefId"
        :arkCodeId="arkCodeId"
        :isFromPotentialCustomer="isFromPotentialCustomer"
        @update:value="fetch"
      />
    </template>
    <template #footer>
      <a-button @click="goBack()">{{ t('btn.cancel') }}</a-button>
      <a-button :loading="loading" @click="handleReset()">{{ t('btn.reset') }}</a-button>
      <a-button type="primary" :loading="loading" @click="handleSubmit()">{{ t('btn.save') }}</a-button>
    </template>
  </CosLayoutMain>
</template>

<script setup lang="ts">
import { ref, reactive, toRaw } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import CosLayoutMain from '@/components/CosLayoutMain/index.vue'
import BusinessForm from './components/BusinessForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { businessCreateOrEdit } from '@/api/overseasSales/chanceManage'
import type { FbuBusinessEditParams } from '@/typings/api/chanceManage'
const route = useRoute()
const { t } = useI18n()

const dataForm = reactive<FbuBusinessEditParams>({})

// 赋值url参数到dataForm
const saleChanceRefId = ref<boolean>()
const arkCodeId = ref<boolean>()
const isFromPotentialCustomer = ref<boolean>() // 是否线索转潜客
if (route.query.saleChanceRefId) {
  dataForm.saleChanceRefId = route.query.saleChanceRefId as string
  saleChanceRefId.value = true
}
if (route.query.arkCodeId) {
  dataForm.arkCodeId = parseInt(route.query.arkCodeId as string)
  arkCodeId.value = true
}
if (route.query.isFromPotentialCustomer) {
  dataForm.isFromPotentialCustomer = true
  isFromPotentialCustomer.value = true
}

const fetch = (val: any) => {
  Object.assign(dataForm, val)
}

const businessFormRef = ref()
const handleReset = () => {
  businessFormRef.value?.resetFields()
}
const loading = ref(false)
const handleSubmit = () => {
  businessFormRef.value?.validate().then(async () => {
    try {
      loading.value = true
      const params = toRaw(dataForm)
      await businessCreateOrEdit(params)
        .then(() => {
          message.success(isFromPotentialCustomer.value ? t('business.ml0kum') : t('business.wvw17m'))
          businessFormRef.value?.resetFields()
          goBack()
        })
        .finally(() => {
          loading.value = false
        })
    } catch (e) {
      loading.value = false
      console.log(e)
    }
  }).catch((error: any) => {
    console.log(error)
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuBusinessAdd' }
</script>

<style scoped></style>
